<template>
  <v-container>
    <v-row>
      <v-col offset-md="2">
        <h2>Manage Menu Links</h2>
        <router-link to="/admin">Back to Admin</router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="8" sm="10" xs="12" offset-md="2">
        <v-list>
          <v-list-item v-for="(link, index) in menuItems" :key="index">
            <v-list-item-content>
              <v-list-item-title>{{ index }} - {{ link.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ link.route }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="editLink(index)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon @click="deleteLink(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="4" sm="6" xs="12" offset-md="2">
        <v-form ref="form" v-model="valid">
          <v-text-field v-model="newLink.title" label="Title" required></v-text-field>
          <v-text-field v-model="newLink.route" label="Route" required></v-text-field>
          <v-text-field v-model="newLink.icon" label="Icon" required></v-text-field>
          <v-checkbox v-model="newLink.external" label="External"></v-checkbox>
          <v-btn @click="addLink" :disabled="!valid" color="success">Add Link</v-btn>
        </v-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col offset-md="2">
        <v-btn @click="updateMenu" color="primary">Update Menu</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { wantBind } from '@/store'

export default {
  data: () => ({
    valid: false,
    menuItems: [],
    newLink: {
      title: '',
      route: '',
      icon: '',
      external: false,
    },
  }),
  computed: {
    siteSettings: function () {
      return this.$store.getters['siteSettings/getAll']()
    },
  },
  watch: {
    siteSettings: {
      handler (newSettings) {
        if (newSettings && newSettings.menuItems) {
          this.menuItems = [...newSettings.menuItems]
        }
      },
      immediate: true,
    },
  },
  mounted: async function () {
    await wantBind(() => { this.$store.dispatch('siteSettings/bindSiteSettings') })
    this.menuItems = [...this.siteSettings.menuItems]
  },
  methods: {
    addLink () {
      this.menuItems.push({ ...this.newLink })
      this.resetForm()
    },
    editLink (index) {
      this.newLink = { ...this.menuItems[index] }
      this.menuItems.splice(index, 1)
    },
    deleteLink (index) {
      this.menuItems.splice(index, 1)
    },
    resetForm () {
      this.newLink = {
        title: '',
        route: '',
        icon: '',
        external: false,
      }
      this.$refs.form.resetValidation()
    },
    async updateMenu () {
      try {
        await this.$store.dispatch('siteSettings/updateMenuLinks', this.menuItems)
        console.log('Menu updated successfully!')
      } catch (error) {
        console.error('Failed to update menu:', error)
      }
    },
  },
}
</script>

<style scoped>
</style>
